export enum BenchmarkMetrics {
  HIGH_SERVER_PERFORMANCE = 10,
  LOW_SERVER_PERFORMANCE = 14,
  HIGH_WORDPRESS_PERFORMANCE = 0.8,
  LOW_WORDPRESS_PERFORMANCE = 1.4,
  PHP_VERSION = 7.4,

}
